import * as Yup from "yup";

interface FormField {
  sort: number;
  is_required?: boolean;
  label: string;
  error_message?: string;
  field_type_id?: number;
  options?: any[];
  value?: string | any[];
}

export const useFormConfig = (formFields: FormField[]|any) => {
  const sortedFormFields = formFields.sort((a: { sort: number; }, b: { sort: number; }) => a.sort - b.sort);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "First Name can only contain letters")
    .required("First Name is required"),
  lastName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Last Name can only contain letters")
    .required("Last Name is required"),
    email: Yup.string()
      .email("Email must be in this pattern (name@domain)")
      .required("Email is required"),
    phone_number: Yup.string()
      .matches(/^\(\d{3}\)\d{3}-\d{4}$/, "Phone number must be in this pattern (123)456-7890")
      .required("Phone number is required"),
    ...sortedFormFields.reduce((schema: any, field: FormField) => {
      if (field.is_required && field.label!=="Checkbox") {
        schema[field.label] = Yup.string().required(field.error_message || "This field is required");
      }
      
      if (field.label === "Multiselect" && field.is_required) {
        schema[field.label] = Yup.array()
          .min(1, field.error_message || "At least one option must be selected")
          .required(field.error_message || "This field is required");
      }
      
      else if (field.label === "Checkbox" && field.is_required) {
        schema[field.label] = Yup.array()
          .min(1, field.error_message || "At least one option must be selected")
          .required(field.error_message || "This field is required");
      }
      
      return schema;
    }, {}),
  });

  return {
    sortedFormFields,
    validationSchema,
  };
};
